// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1Y4KW","vLegacy":"SelectSecondary_vLegacy__34e1Q","error":"SelectSecondary_error__3MMnU","disabled":"SelectSecondary_disabled__1NRnH"};